import React, { useState, useEffect } from "react";
import { Heading } from "@campgladiator/cgui-core.atoms.typography";
import { TableData, TRow, TableDataWithData } from "../..";
import styles from "../../table.module.scss";

export const generateTableHeaderRow = (data: TableData) => {
  const headerData: Set<string> = new Set();
  data.forEach((row) => row.forEach((cell) => headerData.add(cell.header)));
  return [...headerData];
};

const TableHeadRow = ({ data }: TableDataWithData) => {
  const [headerRow, setHeaderRow] = useState<string[]>([]);

  useEffect(() => {
    if (!data) return;
    setHeaderRow(generateTableHeaderRow(data));
  }, [data]);

  return (
    <thead>
      <TRow>
        {headerRow.map((cell, cellIndex) => (
          <th key={cellIndex} className={styles.th}>
            <Heading type="h6">{cell}</Heading>
          </th>
        ))}
      </TRow>
    </thead>
  );
};

export default TableHeadRow;
